import { ChangeEvent, ReactElement, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDeviceType } from '@client/common/hooks';
import { parse } from '@client/common/utils/queryParams';
import { SearchField } from '@client/myAccount/rma/components/SearchPage/SearchField/SearchField';
import { useSearchRmasAction, useSearchRmasData } from '@client/myAccount/rma/hooks';
import { DataAttributesType } from '@lib/utils/getComponentDataAttributes';

export const SearchFieldContainer = ({
  closeButtonDataAttributes,
  submitButtonDataAttributes,
}: {
  closeButtonDataAttributes?: DataAttributesType;
  submitButtonDataAttributes?: DataAttributesType;
}): ReactElement => {
  const previousQueryRef = useRef<string | null>(null);
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState('');
  const { invoiceId } = parse();
  const deviceType = useDeviceType();
  const searchRmas = useSearchRmasAction();
  const data = useSearchRmasData();
  const isLoading = data.isLoading && data.wasStarted;

  useEffect(
    (): void => {
      if ('' !== previousQueryRef.current) {
        if (invoiceId) {
          setSearchQuery(invoiceId);
        } else {
          setSearchQuery('');
        }

        previousQueryRef.current = '';
      }
    },
    [location, invoiceId],
  );

  const handleSubmit = (): void => {
    if (searchQuery !== '' && searchQuery.length > 0) {
      searchRmas(searchQuery.trim());
    }
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const newQuery = event.currentTarget.value;
    searchQuery !== newQuery && setSearchQuery(newQuery);
  };

  const handleClearButtonClick = (): void => {
    setSearchQuery('');
  };

  return (
    <SearchField
      deviceType={deviceType}
      isLoading={isLoading}
      onClearButtonClick={handleClearButtonClick}
      onInputChange={handleInputChange}
      onSubmit={handleSubmit}
      value={searchQuery}
      closeButtonDataAttributes={closeButtonDataAttributes}
      submitButtonDataAttributes={submitButtonDataAttributes}
    />
  );
};
